import { actionCreator } from '@ardoq/rxbeach';
import { ContextSort, Maybe, CidArgs } from '@ardoq/common-helpers';
import {
  ArdoqId,
  APIPresentationAssetAttributes,
  APIWorkspaceAttributes,
} from '@ardoq/api-types';
import { TrackingLocation } from '@ardoq/data-model';
import { Trackable } from 'tracking/trackPayload';

export interface WorkspaceChanged {
  workspaceId: Maybe<ArdoqId>;
}

export const notifyWorkspaceChanged = actionCreator<WorkspaceChanged>(
  '[ContextActions] NOTIFY_WORKSPACE_CHANGED'
);

export type ContextWorkspaceChangedPayload = {
  workspace: APIWorkspaceAttributes;
};

export const contextWorkspaceChanged =
  actionCreator<ContextWorkspaceChangedPayload>(
    '[context] workspace changed with data'
  );

export const notifyScenarioChanged = actionCreator<ArdoqId | null>(
  '[ContextActions] NOTIFY_SCENARIO_CHANGED'
);

export interface PayloadSetSlideId {
  readonly selectedSlideId: ArdoqId;
}

export const setSelectedSlideId = actionCreator<Trackable<PayloadSetSlideId>>(
  '[ContextActions] SET_SLIDE_ID'
);

export const clearSelectedSlide = actionCreator(
  '[ContextActions] CLEAR_SELECTED_SLIDE'
);

export interface PayloadSetLoadedSlideId {
  readonly loadedSlideId: string | null;
}

export const setLoadedSlideId = actionCreator<PayloadSetLoadedSlideId>(
  '[ContextActions] SET_LOADED_SLIDE_ID'
);

export const applicationStarted = actionCreator(
  '[ContextActions] NOTIFY_APPLICATION_STARTED'
);

type NotifyWorkspaceClosedPayload = { workspaceId: ArdoqId };
export const notifyWorkspaceClosed =
  actionCreator<NotifyWorkspaceClosedPayload>(
    '[ContextActions] NOTIFY_WORKSPACE_CLOSED'
  );

export const setSort = actionCreator<ContextSort>('[context] set sort');

export const setPresentation = actionCreator<APIPresentationAssetAttributes>(
  '[context] set presentation'
);

export const clearPresentation = actionCreator('[context] clear presentation');

export const setScenarioId = actionCreator<ArdoqId>(
  '[context] set scenario id'
);

export const clearReference = actionCreator('[context] clear reference');

export const setReference = actionCreator<ArdoqId>('[context] set reference');

export const clearComponentId = actionCreator('[context] clear component id');

export const clearComponent = actionCreator('[context] clear component');

export const setComponentId = actionCreator<ArdoqId>(
  '[context] set component id'
);

export const setWorkspaceIds = actionCreator<ArdoqId[]>(
  '[context] set workspace ids'
);

export const closeAllWorkspaces = actionCreator(
  '[context] close all workspaces'
);

export const closeAllWorkspacesSilently = actionCreator(
  '[context] close all workspaces silently'
);

export const justCloseWorkspaces = actionCreator(
  '[context] just close workspaces'
);

export type ResetStatePayload = { keepCurrentViewPointMode: boolean };
export const resetState = actionCreator<ResetStatePayload>(
  '[context] reset state'
);

type RegisterWorkspacesPayload = { workspaceIds: ArdoqId[] };
export const registerWorkspaces = actionCreator<RegisterWorkspacesPayload>(
  '[context] register workspaces'
);

export const forceUpdateComponent = actionCreator<
  CidArgs & { trackingLocation: TrackingLocation }
>('[context] force update component');

export type CloseWorkspacePayload = {
  workspaceId: ArdoqId;
  options?: {
    isRegisterLoadedState: boolean;
  };
};

export const closeWorkspace = actionCreator<CloseWorkspacePayload>(
  '[context] close workspace'
);

export type LoadWorkspacesAndSetContextPayload = {
  contextWorkspaceId: ArdoqId;
  workspaceIds: ArdoqId[];
};

export const loadWorkspacesAndSetContext =
  actionCreator<LoadWorkspacesAndSetContextPayload>(
    '[context] load workspaces and set context'
  );

export type CloseOtherWorkspacesPayload = {
  keepWorkspaceIds: ArdoqId[];
};

export const closeOtherWorkspaces = actionCreator<CloseOtherWorkspacesPayload>(
  '[context] close other workspaces'
);

export const notifyContextChanged = actionCreator(
  '[ContextActions] CONTEXT_CHANGED'
);

export type SwitchToWorkspacePayload = {
  workspaceId: ArdoqId;
};

export const switchToWorkspace = actionCreator<SwitchToWorkspacePayload>(
  '[context] switch to workspace'
);

export type ForceReloadWorkspacesPayload = {
  workspaceIds: ArdoqId[];
};

export const forceReloadWorkspaces =
  actionCreator<ForceReloadWorkspacesPayload>(
    '[context] force reload workspaces'
  );
